import { useEffect, useRef } from "react";
import { Field } from "@ferrivia/ui";
import { useTranslation } from "@ferrivia/i18n";
import { StepLayout } from "../components/StepLayout";
import { focusWithoutPan } from "../focusWithoutPan";

export interface NameStepProps {
  givenName: string;
  familyName: string;
  onGivenNameChange: (value: string) => void;
  onFamilyNameChange: (value: string) => void;
  onSubmit: () => void;
}

export function NameStep({
  givenName,
  familyName,
  onGivenNameChange,
  onFamilyNameChange,
  onSubmit,
}: NameStepProps) {
  const ref = useRef<HTMLInputElement>(null);
  const { t } = useTranslation("client");

  useEffect(() => {
    ref.current?.focus({ preventScroll: true });
  }, []);

  return (
    <StepLayout title={t("onboarding.name.title", "Mikä sinun nimesi on?")}>
      <Field
        ref={ref}
        label={t("onboarding.name.givenNameLabel", "Etunimi")}
        autoComplete="given-name"
        value={givenName}
        onChange={(e) => onGivenNameChange(e.target.value)}
        onMouseDown={focusWithoutPan}
      />
      <Field
        label={t("onboarding.name.familyNameLabel", "Sukunimi")}
        autoComplete="family-name"
        value={familyName}
        onChange={(e) => onFamilyNameChange(e.target.value)}
        onMouseDown={focusWithoutPan}
        onKeyDown={(e) => {
          if (e.key === "Enter") onSubmit();
        }}
      />
    </StepLayout>
  );
}
